<div class="battlecards-demo" *ngIf="show" role="dialog" aria-modal="true">
  <div class="battlecards-demo__backdrop" (click)="onBackdropClick()"></div>

  <div class="battlecards-demo__panel" (click)="$event.stopPropagation()">
    <button class="battlecards-demo__close" type="button" (click)="close()">
      Back to app
    </button>

    <div class="battlecards-demo__header">
      <div class="battlecards-demo__heading">
        <h2><b>{{ title }}</b></h2>
        <ol class="battlecards-demo__subtitle">
          <li *ngFor="let item of subtitleItems">{{ item }}</li>
        </ol>
      </div>
    </div>

    <div class="battlecards-demo__content">
      <div class="demo-grid">
        <div class="demo-extension">
          <div class="extension-header">
            <div class="extension-title">
              <img class="extension-favicon" src="favicon.ico" alt="convverse.ai" />
              <span class="extension-name">convverse.ai extension</span>
            </div>
            <!-- <span class="extension-pill">Battlecards</span> -->
          </div>

          <div class="extension-body">
            <!-- <div class="source-row">
              <span class="source-label">PDF</span>
              <span class="source-chip">Security-overview.pdf</span>
            </div>
            <div class="source-row">
              <span class="source-label">Domain</span>
              <span class="source-chip">docs.convverse.ai</span>
            </div> -->
          </div>

          <div class="battlecard-pop" [class.visible]="questionVisible">
            <span class="battlecard-pop-dismiss">
              <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </span>
            <div class="battlecard-question">
              Prospect asked: Do you support SOC 2 Type II and SSO? What does onboarding look like?
            </div>
            <div class="battlecard-answers">
              <div class="answer-card">
                <div class="answer-title">From PDF</div>
                <div class="answer-body" *ngIf="loadingAnswers">
                  <span class="loading-dot"></span>
                  Fetching answer...
                </div>
                <div class="answer-body" *ngIf="!loadingAnswers">
                  {{ pdfAnswer }}
                </div>
              </div>
              <div class="answer-card">
                <div class="answer-title">From Web</div>
                <div class="answer-body" *ngIf="loadingAnswers">
                  <span class="loading-dot"></span>
                  Fetching answer...
                </div>
                <div class="answer-body" *ngIf="!loadingAnswers">
                  {{ webAnswer }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="demo-meeting">
          <div class="video-grid">
            <div class="video-tile" [class.speaking]="activeSpeaker === 'rep'">
              <div class="avatar">SR</div>
              <div class="name-tag">
                You
                <span class="mic-pill" [class.on]="activeSpeaker === 'rep'">
                  {{ activeSpeaker === 'rep' ? 'mic' : 'mic off' }}
                </span>
              </div>
            </div>
            <div class="video-tile" [class.speaking]="activeSpeaker === 'prospect'">
              <div class="avatar">VP</div>
              <div class="name-tag">
                Prospect
                <span class="mic-pill" [class.on]="activeSpeaker === 'prospect'">
                  {{ activeSpeaker === 'prospect' ? 'mic' : 'mic off' }}
                </span>
              </div>
            </div>
          </div>

          <div class="live-captions">
            <div class="caption-label">{{ captionName }}</div>
            <div class="caption-text" [class.typing]="isTyping">{{ captionText }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
